import React, { useState, useEffect, useCallback } from 'react';
import * as d3 from 'd3';
import './QueueVisualizer.css';

const QueueVisualizer = () => {
  const [queue, setQueue] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const addToQueue = () => {
    if (inputValue) {
      setQueue([...queue, inputValue]);
      setInputValue('');
    }
  };

  const removeFromQueue = () => {
    if (queue.length > 0) {
      setQueue(queue.slice(1));
    }
  };

  const renderQueue = useCallback(() => {
    const svg = d3.select('#queue-svg');
    svg.selectAll('*').remove(); // Clear previous elements

    // Set dimensions and margins for the SVG
    const width = parseInt(d3.select('#queue-container').style('width')) - 20; // Responsive width
    const height = 200; // Fixed height for better visibility
    const margin = { top: 10, right: 10, bottom: 10, left: 10 };

    svg.attr('width', width).attr('height', height);

    // Create a scale for the queue elements
    const xScale = d3.scaleBand()
      .domain(queue.map((_, index) => index))
      .range([margin.left, width - margin.right])
      .padding(0.1);

    // Create a scale for the heights of the bars
    const yScale = d3.scaleLinear()
      .domain([0, d3.max(queue.map(item => item.length)) || 1])
      .range([height - margin.bottom, margin.top]);

    // Append rectangles for each queue element
    svg.selectAll('rect')
      .data(queue)
      .enter()
      .append('rect')
      .attr('x', (d, i) => xScale(i))
      .attr('y', d => yScale(d.length))
      .attr('width', xScale.bandwidth())
      .attr('height', d => height - margin.bottom - yScale(d.length))
      .attr('fill', '#69b3a2');
      
    // Add text labels above the bars
    svg.selectAll('text')
      .data(queue)
      .enter()
      .append('text')
      .attr('x', (d, i) => xScale(i) + xScale.bandwidth() / 2)
      .attr('y', d => yScale(d.length) - (-1)) // Adjust this value to move text higher
      .attr('text-anchor', 'middle')
      .text(d => d);
      
  }, [queue]);

  useEffect(() => {
    renderQueue();
  }, [queue, renderQueue]);

  return (
    <div className="queue-visualizer" id="queue-container">
      <h2>Queue Visualizer</h2>
      
      <div className="input-section">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Enter value"
        />
        <button onClick={addToQueue}>Add to Queue</button>
        <button onClick={removeFromQueue}>Remove from Queue</button>
      </div>
      
      <svg id="queue-svg"></svg>
      
      <div className="queue-status">
        <h3>Current Queue:</h3>
        <ul>
          {queue.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default QueueVisualizer;
